const previewPopup = document.getElementsByClassName("image-preview__popup")[0];
const openElement = document.getElementsByClassName("open__preview-popup")[0];
const closeElement = $('.close__preview-popup')[0];

if (openElement) {
  openElement.addEventListener("click", function () {
    if (previewPopup.getAttribute("aria-open") == "false") {
      openElement.innerHTML = "Opening book...";
      setTimeout(() => {
        previewPopup.setAttribute("aria-open", "true");
      }, 500);
    }
  });
}

let contentType, btsCardTitle;
const setContentType = (clickedEl) => {
  btsCardTitle = clickedEl.children[0].innerHTML;
  clickedEl.children[0].innerHTML = "Opening...";
  let contentUrl;
  if (clickedEl.getAttribute("content-preview")) {
    contentType = 'img';
    contentUrl = clickedEl.getAttribute("content-preview");
  } else {
    contentType = "iframe";
    contentUrl = clickedEl.getAttribute("video-url");
  }
  return contentUrl;
}

const btsPopupOpen = document.querySelectorAll(".open__bts-preview");
let activeBtsPopup;
if (btsPopupOpen) {
  btsPopupOpen.forEach(el => {
    el.addEventListener('click', (e) => {
      activeBtsPopup = e.target;
      let contentUrl = setContentType(e.target);
      document.querySelector(`.preview-image__loading ${contentType}`).setAttribute("src", contentUrl);
      setTimeout(() => {
        previewPopup.setAttribute("aria-open", "true");
      }, 200);
    })
  })
}

closeElement.addEventListener("click", function () {
  if (previewPopup.getAttribute("aria-open") == "true") {
    if (openElement) {
      openElement.innerHTML = "Read sample";
    } else {
      document.querySelector(`.preview-image__loading ${contentType}`).setAttribute("src", "");
      activeBtsPopup.children[0].innerHTML = btsCardTitle;
    }
    previewPopup.setAttribute("aria-open", "false");
  }
});